import { APP_TYPES } from "@config";
import { initState as initApplicationState } from "@reducers/selectors/application";
import { initState as initDimensionState } from "@reducers/selectors/dimension";
import Panel from "@scene/objects/panel";

export default {
  type: Panel.types.SQUARE,
  width: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.dimensions.d,
  height: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.dimensions.b,
  depth: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.thickness.tfixB,
  dimensions: {
    a: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.dimensions.a, //vertical plate ly
    b: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.dimensions.b, //horizontal plate ly
    c: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.dimensions.c, //vertical plate lx
    d: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.dimensions.d //horizontal plate lx
  },
  thickness: {
    tfixA: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.thickness.tfixA,
    tfixB: initDimensionState[APP_TYPES.WOOD_CONNECTION].bracket.thickness.tfixB
  },
  wood: {
    T: initApplicationState[APP_TYPES.WOOD_CONNECTION].woodPanel.T,
    L: initApplicationState[APP_TYPES.WOOD_CONNECTION].woodPanel.L,
    thicknessE1: initApplicationState[APP_TYPES.WOOD_CONNECTION].woodPanel.thicknessE1,
    thicknessE2: initApplicationState[APP_TYPES.WOOD_CONNECTION].woodPanel.thicknessE2,
  },
  loads: {
    faxd: 0
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/panel/defaults/woodConnection.js